import { emptyModelPath, ModelPath } from "../../../Common/ModelPath/ModelPath";
import { ViewModel } from "../Engine/Core/CoreTypes";
import { getNestedNodeViewModels, getViewModel, NodeViewModel } from "../Engine/Core/Store/FormViewModel";

export function isNodeOrChildrenContainsError(node: NodeViewModel): boolean {
    const viewModel = getViewModel(node);
    if (viewModel != undefined && viewModel.error != undefined && Array.isArray(viewModel.error)) {
        if (viewModel.error.length > 0) {
            return true;
        }
    }
    return getNestedNodeViewModels(node).some(([, nestedNode]) => isNodeOrChildrenContainsError(nestedNode));
}

export function isNodeOrChildrenContainsNotEmptyValue(object: NodeViewModel): boolean {
    const viewModel = getViewModel(object);
    if (viewModel != undefined && Boolean(viewModel.value)) {
        return true;
    }

    for (const [, value] of getNestedNodeViewModels(object)) {
        if (isNodeOrChildrenContainsNotEmptyValue(value)) {
            return true;
        }
    }
    return false;
}

export function* iterateModelEntries(
    node: NodeViewModel,
    path: ModelPath = emptyModelPath()
): Iterable<[ModelPath, ViewModel]> {
    const viewModel = getViewModel(node);
    if (viewModel != undefined) {
        yield [path, viewModel];
    }
    for (const [childPathToken, value] of getNestedNodeViewModels(node)) {
        yield* iterateModelEntries(value, path.joinWith(childPathToken));
    }
}

export function iterateViewModels(node: NodeViewModel): Iterable<ViewModel> {
    return Iterator.from(iterateModelEntries(node)).map(([_path, viewModel]) => viewModel);
}
